/**
 * Unified sample / add-to-cart behavior (Refresh theme).
 *
 * ONE path for every sample CTA — body `.sample-atc-btn` buttons, the buy-area
 * `a.om-sample-card`, and legacy inline-onclick sample links/buttons:
 *   add  →  open the slide-out cart drawer  →  fire add_to_cart tracking.
 *
 * Tracking is preserved by routing single adds through
 * `window.ILCartEvents.addToCartWithTracking` (standard Shopify headers, so WPM
 * auto-emits product_added_to_cart for Littledata/GA4/Ads) and by dispatching
 * `cart:updated` (which ild-google-ads-events.js listens to for GA4 + labeled
 * Google Ads add_to_cart). Never `window.location='/cart'` — that aborts pixels.
 *
 * (Previously the cart script lived only in product-v2-value-stack.liquid; hiding that
 * section for DeepSleep removed all click handlers for description-only sample buttons.)
 */
(function () {
  var variantProductMap = {
    '47745089569010': '/products/deepsleep-sample.js',
    '47781834719474': '/products/painrelief-sample.js',
    '48457116451058': '/products/breatheeasy-sample.js',
    '17866586587251': '/products/breatheeasy-rx-sample.js',
    '48740887691506': '/products/skinmiracle-mist-sample.js',
    '47695313535218': '/products/oralmiracle-sample.js',
  };
  var priceCache = {};

  function fetchVariantPrice(variantId, cb) {
    if (priceCache[variantId]) {
      cb(priceCache[variantId]);
      return;
    }
    var url = variantProductMap[variantId];
    if (!url) return;
    fetch(url)
      .then(function (r) {
        if (!r.ok) throw new Error('fetch failed');
        return r.json();
      })
      .then(function (p) {
        var variants = p.variants || [];
        var v = variants.find(function (x) {
          return String(x.id) === String(variantId);
        });
        if (v && v.price) {
          var price = (v.price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
          priceCache[variantId] = price;
          cb(price);
        }
      })
      .catch(function () {});
  }

  function hydrateSamplePrices() {
    document.querySelectorAll('.sample-price').forEach(function (span) {
      var id = span.getAttribute('data-variant-id');
      if (!id) return;
      fetchVariantPrice(id, function (price) {
        span.textContent = price;
      });
    });
  }

  /* ---------------------------------------------------------------------------
   * Unified add-to-cart core (tracking-safe + opens the slide-out drawer).
   * ------------------------------------------------------------------------- */
  function getCartTarget() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function standardAdd(ids, cartTarget) {
    cartTarget = cartTarget || getCartTarget();

    // Single variant → route through ILCartEvents so Shopify WPM auto-emits
    // product_added_to_cart AND ild-google-ads fires GA4/Ads add_to_cart.
    if (ids.length === 1 && window.ILCartEvents && typeof window.ILCartEvents.addToCartWithTracking === 'function') {
      return window.ILCartEvents.addToCartWithTracking({ variantId: ids[0], quantity: 1, cartTarget: cartTarget });
    }

    // Multi-item (combo) or ILCartEvents unavailable → standard-header fetch
    // (same request shape as product-form.js, so WPM still auto-emits).
    var fd = new FormData();
    if (ids.length > 1) {
      ids.forEach(function (id, i) {
        fd.append('items[' + i + '][id]', id);
        fd.append('items[' + i + '][quantity]', 1);
      });
    } else {
      fd.append('id', ids[0]);
      fd.append('quantity', 1);
    }
    if (cartTarget && typeof cartTarget.getSectionsToRender === 'function') {
      fd.append('sections', cartTarget.getSectionsToRender().map(function (s) { return s.id; }));
      fd.append('sections_url', window.location.pathname);
    }
    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
    return fetch(url, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd,
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.status) throw data;
        return data;
      });
  }

  function openDrawer(data) {
    // Same payload object that ILCartEvents already flagged → ild-google-ads dedupes.
    try { window.dispatchEvent(new CustomEvent('cart:updated', { detail: data })); } catch (e) {}
    var cartDrawer = document.querySelector('cart-drawer');
    var cartNotification = document.querySelector('cart-notification');
    if (cartDrawer && data && data.sections) {
      cartDrawer.classList.remove('is-empty');
      cartDrawer.renderContents(data); // renderContents(state, shouldOpen=true) → slides open
    } else if (cartNotification && data && data.sections) {
      cartNotification.renderContents(data);
    } else if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.classList.remove('is-empty');
      cartDrawer.open();
    } else if (cartNotification && typeof cartNotification.open === 'function') {
      cartNotification.open();
    }
  }

  /* Convert legacy inline-onclick CTAs (om-sample-card + legacy sample links/buttons
     that fetch /cart/add then window.location='/cart') to the unified drawer path. */
  function unifyInlineSampleCtas() {
    document.querySelectorAll('a[onclick], button[onclick]').forEach(function (el) {
      if (el.getAttribute('data-immunize-unified') === '1') return;
      var oc = el.getAttribute('onclick') || '';
      if (oc.indexOf('cart/add') === -1) return;

      var ids = [];
      var itemsMatch = oc.match(/items\s*:\s*\[([\s\S]*?)\]/);
      if (itemsMatch) {
        var re = /id\s*:\s*(\d+)/g, m;
        while ((m = re.exec(itemsMatch[1]))) ids.push(m[1]);
      } else {
        var single = oc.match(/id\s*:\s*(\d+)/);
        if (single) ids.push(single[1]);
      }
      if (!ids.length) return;

      el.setAttribute('data-immunize-unified', '1');
      el.removeAttribute('onclick'); // neutralize the add-then-redirect behavior
      el.addEventListener('click', function (e) {
        e.preventDefault();
        var self = this;
        if (self._imnBusy) return;
        self._imnBusy = true;
        var prevOpacity = self.style.opacity;
        self.style.opacity = '0.6';
        self.style.pointerEvents = 'none';
        standardAdd(ids, getCartTarget())
          .then(function (data) { openDrawer(data); })
          .catch(function (err) { console.error('[immunize sample atc] add failed:', err); })
          .finally(function () {
            self._imnBusy = false;
            self.style.opacity = prevOpacity || '';
            self.style.pointerEvents = '';
          });
      });
    });
  }

  function injectImnAtcStyles() {
    if (document.getElementById('immunize-imn-atc-styles')) return;
    var style = document.createElement('style');
    style.id = 'immunize-imn-atc-styles';
    style.textContent =
      '[data-imn-atc]{text-align:center;}' +
      '[data-imn-atc] .sample-atc-btn{display:block;width:100%;max-width:380px;margin:0 auto;background:#044f89!important;color:#fff!important;font-size:16px!important;font-weight:800!important;padding:14px 20px!important;border-radius:999px!important;border:0!important;cursor:pointer;text-align:center;line-height:1.35;font-family:inherit;box-sizing:border-box;}' +
      '[data-imn-atc] .sample-atc-btn:hover{background:#033d6b!important;}' +
      '[data-imn-atc] .sample-atc-btn:disabled{background:#6b7280!important;cursor:default;}' +
      '[data-imn-atc] .sample-atc-sub{display:block;font-size:13px!important;font-weight:600!important;margin-top:4px;color:inherit!important;}' +
      '[data-imn-atc] .sample-atc-confirm{font-size:14px!important;font-weight:700!important;color:#166534!important;margin:10px 0 0!important;text-align:center!important;}';
    document.head.appendChild(style);
  }

  function buildPlaceholderButtonLine(line, config) {
    var label = (config.t || 'Try the sample').replace(/\s*-\>\s*$/, '').trim();
    var match = label.match(/^(.+?)\s*(\$\d+(?:\.\d{2})?)\s+sample$/i);

    if (!match) {
      line.textContent = label;
      return;
    }

    line.appendChild(document.createTextNode('✦ Try ' + match[1].trim() + ' Sample — '));
    var price = document.createElement('span');
    price.className = 'sample-price';
    price.setAttribute('data-variant-id', config.v);
    price.textContent = match[2];
    line.appendChild(price);
  }

  function upgradeImnAtcPlaceholders() {
    document.querySelectorAll('[data-imn-atc]').forEach(function (placeholder) {
      if (placeholder.getAttribute('data-immunize-atc-upgraded') === '1') return;

      var config;
      try {
        config = JSON.parse(placeholder.getAttribute('data-imn-atc') || '{}');
      } catch (err) {
        return;
      }

      if (!config.v) return;
      placeholder.setAttribute('data-immunize-atc-upgraded', '1');
      injectImnAtcStyles();

      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'sample-atc-btn';
      button.setAttribute('data-variant-id', config.v);

      var line = document.createElement('span');
      line.className = 'sample-atc-line';
      buildPlaceholderButtonLine(line, config);
      button.appendChild(line);

      if (config.s) {
        var sub = document.createElement('span');
        sub.className = 'sample-atc-sub';
        sub.textContent = config.s;
        button.appendChild(sub);
      }

      var confirm = document.createElement('p');
      confirm.className = 'sample-atc-confirm';
      confirm.setAttribute('data-variant-id', config.v);
      confirm.style.display = 'none';
      confirm.textContent = 'Sample added to your cart';

      placeholder.replaceChildren(button, confirm);
    });
  }

  function bindGlobalSampleAtcButtons() {
    document.querySelectorAll('.sample-atc-btn').forEach(function (btn) {
      if (btn.getAttribute('data-immunize-atc-cart-bound') === '1') return;
      btn.setAttribute('data-immunize-atc-cart-bound', '1');
      btn.addEventListener('click', function () {
        var self = this;
        if (!self._immunizeSampleHtmlBackup) {
          self._immunizeSampleHtmlBackup = self.innerHTML;
        }
        var variantId = self.getAttribute('data-variant-id');
        if (!variantId) return;
        self.disabled = true;
        self.textContent = 'Adding...';
        standardAdd([variantId], getCartTarget())
          .then(function (data) {
            openDrawer(data);
            self.style.display = 'none';
            var confirm = document.querySelector('.sample-atc-confirm[data-variant-id="' + variantId + '"]');
            if (confirm) confirm.style.setProperty('display', 'block', 'important');
          })
          .catch(function (err) {
            console.error('Cart add failed:', err);
            self.disabled = false;
            self.innerHTML = self._immunizeSampleHtmlBackup || self.innerHTML;
          });
      });
    });
  }

  /* "Try Both Samples" buttons: data-variant-ids="id1,id2" -> one add (standardAdd already
   * builds items[] for >1 id) -> open the drawer -> show the sibling .sample-atc-confirm. */
  function bindBothSampleButtons() {
    document.querySelectorAll('.sample-atc-both[data-variant-ids]').forEach(function (btn) {
      if (btn.getAttribute('data-immunize-atc-cart-bound') === '1') return;
      btn.setAttribute('data-immunize-atc-cart-bound', '1');
      btn.addEventListener('click', function () {
        var self = this;
        if (!self._immunizeSampleHtmlBackup) {
          self._immunizeSampleHtmlBackup = self.innerHTML;
        }
        var ids = (self.getAttribute('data-variant-ids') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
        if (!ids.length) return;
        self.disabled = true;
        self.textContent = 'Adding...';
        standardAdd(ids, getCartTarget())
          .then(function (data) {
            openDrawer(data);
            self.style.display = 'none';
            var confirm = self.nextElementSibling;
            if (confirm && confirm.classList.contains('sample-atc-confirm')) confirm.style.setProperty('display', 'block', 'important');
          })
          .catch(function (err) {
            console.error('Cart add (both samples) failed:', err);
            self.disabled = false;
            self.innerHTML = self._immunizeSampleHtmlBackup || self.innerHTML;
          });
      });
    });
  }

  function resetProductDescriptionSampleUi() {
    document.querySelectorAll('.product__description .sample-atc-confirm').forEach(function (el) {
      /* Never use removeProperty('display') here — it strips inline/author hiding and leaves <p> as visible block if CSS did not deploy or loses specificity. */
      el.style.setProperty('display', 'none', 'important');
    });
    document.querySelectorAll('.product__description .sample-atc-btn').forEach(function (btn) {
      btn.style.removeProperty('display');
      btn.disabled = false;
    });
  }

  function observeConfirm(el) {
    if (el.getAttribute('data-immunize-atc-obs') === '1') return;
    el.setAttribute('data-immunize-atc-obs', '1');
    new MutationObserver(function () {
      if (
        el.style.getPropertyValue('display') === 'block' &&
        el.style.getPropertyPriority('display') !== 'important'
      ) {
        el.style.setProperty('display', 'block', 'important');
      }
    }).observe(el, { attributes: true, attributeFilter: ['style'] });
  }

  function init() {
    upgradeImnAtcPlaceholders();
    resetProductDescriptionSampleUi();
    document.querySelectorAll('.product__description .sample-atc-confirm').forEach(observeConfirm);
    hydrateSamplePrices();
    bindGlobalSampleAtcButtons();
    bindBothSampleButtons();
    unifyInlineSampleCtas();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('pageshow', resetProductDescriptionSampleUi);
})();
